<template>
  <div class="trip-place-wrapper">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ place.name }}</span>
      </div>
      <div>{{ place.details }}</div>
      <div>
        <el-link :href="place.link" target="_blank"
          >查看攻略<i class="el-icon-view el-icon--right"></i
        ></el-link>
      </div>
      <div><el-link type="primary" @click="$emit('toggleInfoWindow', place, idx)">去地图</el-link></div>
      <div>
        <el-button type="primary" @click="$emit('selectLocation', 'start', {lng: place.location[0], lat: place.location[1]})">设为起点</el-button>
        <el-button type="success" @click="$emit('selectLocation', 'end', {lng: place.location[0], lat: place.location[1]})">设为终点</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    place: Object,
    idx: Number
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style>
.trip-place-wrapper {
  text-align: left;
  margin-bottom: 30px !important;
  width: 90%;
  margin: auto;
}
</style>
